export default __webpack_public_path__ + "static/media/icon-admin-gray.b5dff41f.svg";